<template>
	<div class="flex flex-col space-y-2" v-bind="$attrs">

		<!-- Label Details above the text input-->
		<div v-if="label || cornerHint" class="flex justify-between">

			<!-- The Label-->
			<label :for="name" class="block text-sm font-medium leading-6 text-surface-900 dark:text-surface-200">{{ label }}</label>

			<!-- Corner Hint -->
			<span v-if="cornerHint" class="text-sm leading-6 text-surface-500 dark:text-surface-400">{{ cornerHint }}</span>

		</div>

    <!-- Helper text above the input -->
    <p v-if="helpText && helpTextPositionTop" class="text-sm text-gray-500 pb-1">{{ helpText }}</p>

		<!-- For the form input -->
		<slot></slot>

		<!-- Helper text below the input -->
		<p v-if="helpText && !helpTextPositionTop" class="text-sm text-gray-500">{{ helpText }}</p>

		<!-- Error message below the input -->
		<p v-if="errorText" class="text-sm text-red-600">{{ errorText }}</p>

	</div>
</template>

<script>
export default {
	name: "FormGroup",
	inheritAttrs: false,
	props: {
		name: String,
		label: String,
		cornerHint: String,
		helpText: String,
    helpTextPositionTop: Boolean,
		errorText: String
	},
}
</script>

<style scoped>

</style>